import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const Zarizeni = {
	name: NAME,
	apiProvider,
	router,
};
